module.exports = __webpack_public_path__ + "static/img/bussinessTv1.5c8a033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussinessTv1.png
// module id = +72p
// module chunks = 2